module.exports = __webpack_public_path__ + "static/media/maestro.a591b96a.svg";